import React from "react";
import { observer } from "mobx-react-lite";
import { Descriptions } from "antd";
import WorkbenchWidgetCard from "./WorkbenchWidgetCard";
import { useWorkbenchStore } from "../stores/context";
import { Utils } from "../../common/misc/Utils";

const formatDate = (value?: string | null) =>
    value ? Utils.formatDateStringShort(value, true, true) : "N/A";

const SubjectInfoWidget: React.FC = () => {
    const { workbenchStore } = useWorkbenchStore();

    const renderSubjectContent = () => {
        const subject = workbenchStore.subjectData;
        if (!subject) {
            return <div>No subject information available</div>;
        }

        const period =
            subject.periodFrom || subject.periodTo
                ? `${formatDate(subject.periodFrom)} - ${formatDate(subject.periodTo)}`
                : "N/A";

        return (
            <Descriptions column={1} size="small" bordered={true}>
                <Descriptions.Item label="Kind">
                    {subject.kind}
                </Descriptions.Item>
                <Descriptions.Item label="Identifier">
                    {subject.identifier}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                    {subject.state.overallStatus}
                </Descriptions.Item>
                <Descriptions.Item label="Tasks">
                    {`${subject.state.openTasks} open / ${subject.state.totalTasks} total`}
                </Descriptions.Item>
                <Descriptions.Item label="Cedent">
                    {subject.cedent ||
                        subject.context?.cedent ||
                        subject.context?.broker ||
                        "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Period">{period}</Descriptions.Item>
                <Descriptions.Item label="Last Updated">
                    {formatDate(subject.state.lastUpdatedAt)}
                </Descriptions.Item>
                <Descriptions.Item label="Broker">
                    {subject.context?.broker || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Claimant">
                    {subject.context?.claimant || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Date of Loss">
                    {formatDate(subject.context?.dateOfLoss)}
                </Descriptions.Item>
                <Descriptions.Item label="UW Year">
                    {subject.context?.uwYear ?? "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Main Class">
                    {subject.context?.mainClass || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Currency">
                    {subject.context?.currency || "N/A"}
                </Descriptions.Item>
            </Descriptions>
        );
    };

    return (
        <WorkbenchWidgetCard
            title="Subject"
            widgetState={workbenchStore.subjectInfoWidget}
        >
            {renderSubjectContent()}
        </WorkbenchWidgetCard>
    );
};

export default observer(SubjectInfoWidget);
